export default angular.module('syAffix', [])
    /**
     * @ngdoc directive
     * @name affix.directive:affix
     * @description
     * Fixes an element to the bottom of the screen until the page is scrolled
     * down to display the element naturally
     */
    // @ngInject
    .directive('syAffix', function ($document, $window) {
        return {
            link: function ($scope, $element, attrs) {
                var $parent = $element.parent();
                var scrollOffset = parseInt(attrs.syAffixScrollOffset, 10) || 0;
                // On screen change (scroll or resize) add a class to the affixed
                // element if the element is not currently in the viewport
                angular.element($window).on('load scroll resize', function () {
                    var windowHeight = $window.innerHeight;
                    var parentTop = $parent[0].getBoundingClientRect().top;
                    $element.toggleClass(attrs.syAffixClass || 'affix', parentTop > windowHeight);
                });
                // On click scroll the user to the natrual location of the element
                $element.on('click touchstart', function () {
                    if ($window.innerWidth < 610) {
                        var elementHeight = $element[0].getBoundingClientRect().height;
                        $document.scrollToElementAnimated($parent, elementHeight + scrollOffset, 300);
                    }
                });
            }
        };
    });
